import { Avatar, Badge, Flex, Square, Text, VStack } from '@chakra-ui/react';
import { ProviderUserRoleColorSchemes } from '@duke-hq/shared-constants/providers';
import type { ConsultantRoleType } from '@duke-hq/svc-api/provider/util/consultants';
import { chakraComponents, OptionProps } from 'chakra-react-select';

interface ConsultantOption {
  label: string;
  value: string;
  email: string;
  role: ConsultantRoleType;
  fullname: string;
  picture_url?: string;
}

export function Option(props: OptionProps<ConsultantOption>) {
  return (
    <chakraComponents.Option {...props}>
      <Flex align="center" justify="space-between" w="full">
        <Flex align="center">
          <Square size="32px">
            <Avatar
              size="sm"
              name={props.data.fullname}
              src={props.data.picture_url ?? undefined}
            />
          </Square>
          <VStack align="flex-start" gap={0} ml={4}>
            <Text fontWeight="medium">{`${props.data.label}`}</Text>
            <Text fontSize="sm" color={'fg.muted'}>{`${props.data.email}`}</Text>
          </VStack>
        </Flex>
        <Flex align="flex-end">
          <Badge
            borderRadius="full"
            colorScheme={ProviderUserRoleColorSchemes[props.data.role] ?? 'gray'}
            variant="muted"
            textTransform="none"
          >
            {props.data.role.replace(/_/g, ' ')}
          </Badge>
        </Flex>
      </Flex>
    </chakraComponents.Option>
  );
}
